import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class TableService {
  private readonly refreshSource$ = new Subject<void>();

  public get refresh$(): Observable<void> {
    return this.refreshSource$.asObservable();
  }

  public refresh(): void {
    this.refreshSource$.next();
  }
}
